import React from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import TenantEditHead from '../../TenantEditHead'
import { ThemeProvider, withStyles, createMuiTheme } from '@material-ui/core/styles';
import ConfigureWorkspacesBase from './ConfigureWorkspacesBase'
import * as actions from '../../../../store/actions/configureWorkspacesAction'
import Toast from '../../../../crud/Toast'


export default function ConfigureWorkspaces(props){
    const { match, tenant } = props
    const dispatch = useDispatch()
    const [level, setLevel] = React.useState('')
    const [message, setMessage] = React.useState('')
    const [toastVisible, setToastVisible] = React.useState(false)
    const loader = document.getElementById('splash-screen');
    const {tenentSuccess, tenantMassage, error} = useSelector((state) => ({
        tenentSuccess: state.configureWorkspaces.success,
        tenantMassage: state.configureWorkspaces.message,
        error: state.configureWorkspaces.error
    }), shallowEqual)
    
    React.useEffect(() => {
        if(tenentSuccess){
            setLevel('success')
            setMessage(tenantMassage)
            setToastVisible(tenentSuccess)
            loader.classList.add('hidden')
            setTimeout(() => {
                dispatch(actions.reset())
                setLevel('')
                setMessage('')
                setToastVisible(false)
            }, 5000)
        }else { 
            setLevel('')
            setMessage('')
            setToastVisible(false)
        }
    }, [tenentSuccess, tenantMassage])
    React.useEffect(() => {
        if(error){
            setLevel('danger')
            setMessage(error)
            setToastVisible(true)
            loader.classList.add('hidden')
            setTimeout(() => {
                dispatch(actions.reset())
                setLevel('')
                setMessage('')
                setToastVisible(false)
            }, 5000)
        }
    }, [error, dispatch])
    return(
        <ThemeProvider theme={theme}>
            {tenant && <TenantEditHead tenant={tenant} />}
            <div style={{padding: 10}}>
                <ConfigureWorkspacesBase match={match} tenant={tenant}/>
            </div>
            <Toast
                level={level}
                message={message}
                visible={toastVisible}
            />
        </ThemeProvider>
    )
}

const theme = createMuiTheme({
    overrides: {
        MuiExpansionPanelSummary: {
            content: {
                padding: 0,
                margin: '0px !important'
            }
        },
        MuiPagination: {
            root: {
                marginTop: 10,
                alignItems: 'center'
            },
            ul: {
                marginTop: 10,
                alignItems: 'center'
            }
        },
        MuiButtonBase: {
            root: {
                minHeight: '25px !important',
                lineHeight: '1.2 !important'
            },
            expandIcon: {
                padding: 5
            },
        },
        MuiButton: {
            text: {
                color: '#333333',
            },
            containedPrimary: {
                backgroundColor: '#0078d4',
                '&:hover': {
                    backgroundColor: '#0078d4',
                }
            }
        },
        MuiExpansionPanelDetails: {
            root: {
                padding: '0px !important',
                backgroundColor: 'rgba(0, 0, 0, 0.0) !important'
            }
        },
        PrivateSwitchBase:{
            root:{
                padding: 0
            }
        },
        MuiTableCell: {
            root: {
                padding: 5,
                fontSize: '1rem'
            },
            head: {
                lineHeight: '2.5rem'
            },
            sizeSmall: {
                padding: 5,
            },
            stickyHeader: {
                backgroundColor: '#ffffff'
            }
        },
        MuiFormControl: {
            root: {
                width: 'auto'
            }
        },
        MuiFormControlLabel: {
            root: {
                marginBottom: 0,
                marginLeft: 0
            }
        },
        MuiList: {
            padding: {
                paddingTop: 0,
                paddingBottom: 0,
            }
        },
        MuiListItem: {
            root: {
                paddingTop: 0,
                paddingBottom: 0,
            }
        },
        MuiTooltip: {
            tooltip: {
                fontSize: 14
            }
        },
        MuiInputLabel: {
            formControl: {
                transform: 'translate(0, 7px) scale(1)'
            },
            shrink: {
                transform: 'translate(0, 31px) scale(0.75)'
            }
        },
        MuiInput: {
            formControl: {
                marginTop: '0 !important'
            }
        }
    },
});